<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title mb-4">
        {{ $t("Online Aggregators Transaction Report") }}
      </div>

      <div class="row">
        <div class="col-md-4 col-lg-3 col-xl-3 mb-4">
          <div class="input-material">
            <div class="add-datepicker">
              <button
                class="btn-clearDate"
                v-if="getAggregatorsReportFromDate"
                v-on:click="
                  onAggregatorsReportDateHandler({
                    event: null,
                    name: 'fromDate',
                  })
                "
              >
                ✖
              </button>
              <Datepicker
                :monday-first="true"
                :value="getAggregatorsReportFromDate"
                typeable
                @selected="
                  onAggregatorsReportDateHandler({
                    event: $event,
                    name: 'fromDate',
                  })
                "
                ref="programaticOpen"
                v-validate="'required'"
              ></Datepicker>
              <label :class="getAggregatorsReportFromDate ? 'active' : ''"
                >{{ $tc("show") }} {{ $tc("fromdate") }}</label
              >
            </div>
          </div>
        </div>

        <div class="col-md-4 col-lg-3 col-xl-3 mb-4">
          <div class="input-material">
            <div class="add-datepicker">
              <button
                class="btn-clearDate"
                v-if="getAggregatorsReportToDate"
                v-on:click="
                  onAggregatorsReportDateHandler({
                    event: null,
                    name: 'toDate',
                  })
                "
              >
                ✖
              </button>
              <Datepicker
                :monday-first="true"
                :value="getAggregatorsReportToDate"
                typeable
                @selected="
                  onAggregatorsReportDateHandler({
                    event: $event,
                    name: 'toDate',
                  })
                "
                ref="programaticOpen"
                v-validate="'required'"
              ></Datepicker>
              <label :class="getAggregatorsReportToDate ? 'active' : ''"
                >{{ $tc("show") }} {{ $tc("todate") }}</label
              >
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-xl-2 align-self-center mb-4">
          <div class="dropdown-curve-container mr-2">
            <!-- <button v-if="selectedFilter" v-on:click="clearFilter()" class="btn-clearDate">✖</button> -->
            <label :class="selectedFilter ? 'shift-up' : ''"
              >{{ $t("select") }} {{ $tc("filter") }}</label
            >
            <b-dropdown
              :text="selectedFilter"
              name="selectuser"
              id="selectcinema"
              variant="dropdown-curve"
              class="w-100"
            >
              <b-dropdown-item
                href="#"
                v-for="(filter, FilterIndex) in SearchFilters"
                :key="FilterIndex"
                @click="onSelectFilter(filter)"
                >{{ filter.name }}</b-dropdown-item
              >
            </b-dropdown>
          </div>
        </div>
        <div
          v-if="selectedFilter"
          class="col-lg-4 col-xl-3 align-self-center mb-4"
        >
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                type="text"
                v-model="filtervalue"
                name="firstname"
                id="firstname"
                @input="onAggregatorsReportSearchHandler($event.target.value)"
              />
              <label>{{ $t("search") }} {{ selectedFilter }}</label>
            </div>
          </div>
        </div>
        <div class="col-md-2">
          <button
            class="btn-blue-lg mb-3"
            @click.prevent.stop="fetchAggregatorsReportList"
          >
            {{ $tc("fetch") }} {{ $tc("report") }}
          </button>
        </div>

        <div
          v-if="getAggregatorsReportList.length > 0"
          class="col-md-3 d-flex justify-content-end align-items-center"
        >
          <div>{{ $t("download") }} as:</div>
          <a
            v-if="getAggregatorsPdfFileName"
            :href="BASE_URL + getAggregatorsPdfFileName"
            target="_blank"
            download
            title="Download as PDF"
          >
            <img src="@/assets/img/icons/pdf-icon.svg" height="25" width="25" />
          </a>

          <a
            v-if="getAggregatorsExcelFileName"
            :href="BASE_URL + getAggregatorsExcelFileName"
            target="_blank"
            title="Download as Excel"
            download
          >
            <img src="@/assets/img/icons/excel.svg" height="25" width="25" />
          </a>
        </div>

        <div class="col">
          <div class="d-table ml-auto">
            <!-- <b-dropdown id="listview" variant="outline-blue-lg">
              <template v-slot:button-content>
                Viewing&nbsp;
                <strong>{{selectedvalue}}</strong>
                &nbsp;Of&nbsp;
                <strong>{{ rows }}</strong>
              </template>
              <b-dropdown-item
                v-for="(list, listIndex) in viewingnumbers"
                :key="listIndex"
                @click="onDropDownChangeValue(list.name)"
                href="#"
              >{{list.name}}</b-dropdown-item>
            </b-dropdown>-->
          </div>
        </div>
      </div>

      <div class="swc-report">
        <table class="swc-report-table" border="1">
          <thead>
            <tr>
              <th class="bg-lightgrey">Cinema Name</th>
              <th class="bg-lightgrey">{{ $tc("transaction") }} Id</th>
              <th class="bg-lightgrey">{{ $tc("film") }}</th>
              <th class="bg-lightgrey">
                {{ $tc("date") }} & {{ $tc("time") }}
              </th>
              <th class="bg-lightgrey">{{ $tc("screen") }}</th>
              <th class="bg-lightgrey">No. Of {{ $tc("ticket") }}</th>
              <th class="bg-lightgrey">Discount</th>
              <th class="bg-lightgrey">{{ $tc("netamount") }}</th>
              <th class="bg-lightgrey">{{ $tc("grossamount") }}</th>
              <th class="bg-lightgrey">{{ $tc("internetFee") }}</th>
              <th class="bg-lightgrey">{{ $tc("totalamount") }}</th>
              <th class="bg-lightgrey">{{ $tc("aggregatorName") }}</th>
              <th class="bg-lightgrey">
                {{ $tc("payment") }} {{ $tc("mode") }}
              </th>
              <!-- <th class="bg-lightgrey">Sold</th>
              <th class="bg-lightgrey">Redeemed On</th>-->
            </tr>
          </thead>
          <tbody>
            <tr v-if="getAggregatorsReportList.length == 0">
              <td colspan="12">
                <!-- <p class="h6 text-center">
                 {{ $tc("NoRecords") }}
                </p> -->
                <NoRecords />
              </td>
            </tr>
            <tr
              v-if="getAggregatorsReportList.length > 0"
              v-for="(
                transaction, transactionIndex
              ) in getAggregatorsReportList"
              :key="transactionIndex"
            >
              <td>{{ transaction.cinema_name }}</td>
              <td>{{ transaction.sb_booking_code }}</td>
              <td class="text-left">{{ transaction.film_name }}</td>
              <td>
                {{ transaction.t_show_date | dateparse }}
                {{ transaction.t_show_time }}
              </td>
              <td>{{ transaction.screen_name }}</td>
              <td class="text-right">{{ transaction.no_of_tickets }}</td>
              <td class="text-right">
                {{ currFormat(transaction.offer_price) }}
              </td>
              <td class="text-right">
                {{ currFormat(transaction.net_total_amount) }}
              </td>
              <td class="text-right">
                {{ currFormat(transaction.gross_total_amount) }}
              </td>
              <td class="text-right">
                {{ currFormat(transaction.internet_handling_fee) }}
              </td>
              <td class="text-right">
                {{
                  currFormat(
                    transaction.gross_total_amount +
                      transaction.internet_handling_fee
                  )
                }}
              </td>
              <td class="text-left">
                {{ transaction.aggregator_name || "-" }}
              </td>
              <td class="text-left">{{ transaction.payment_mode || "-" }}</td>
            </tr>
            <!-- <tr>
              <td colspan="3">Tick</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>

            <tr>
              <td colspan="3">Test</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>

            <tr>
              <td>15/09/19</td>
              <td colspan="3"></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            

            <tr>
              <td rowspan="2">
                <div style="padding-bottom: 5px;">1203</div>
                <div style="padding-bottom: 5px;">1204</div>
              </td>
              <td>
                <div style="padding-bottom: 5px;">77537</div>
                <div style="padding-bottom: 5px;">77541</div>
              </td>
              <td>
                <div style="padding-bottom: 5px;">KAAPPAAN (2D) (TAM) (PG15)</div>
                <div style="padding-bottom: 5px;">KAAPPAAN (2D) (TAM) (PG15)</div>
              </td>
              <td>
                <div style="padding-bottom: 5px;">
                  20/09/19
                  <span style="margin-left: 5px;">5:45 PM</span>
                </div>
                <div style="padding-bottom: 5px;">
                  20/09/19
                  <span style="margin-left: 5px;">5:45 PM</span>
                </div>
              </td>
              <td>
                <div style="padding-bottom: 5px;">50</div>
                <div style="padding-bottom: 5px;">50</div>
              </td>
              <td>
                <div style="padding-bottom: 5px;">2</div>
                <div style="padding-bottom: 5px;">1</div>
              </td>
              <td>
                <div style="padding-bottom: 5px;">58.80</div>
                <div style="padding-bottom: 5px;">31.24</div>
              </td>
              <td>
                <div style="padding-bottom: 5px;">58.80</div>
                <div style="padding-bottom: 5px;">31.24</div>
              </td>
              <td>
                <div style="padding-bottom: 5px;">20/09/19</div>
                <div style="padding-bottom: 5px;">20/09/19</div>
              </td>
            </tr>-->
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters, mapActions } from "vuex";
import NoRecords from "@/components/Partials/NoRecords.vue";

export default {
  components: {
    NoRecords,
  },
  data() {
    return {
      SearchFilters: [
        { name: "Movie", query: "t.movie_name" },
        { name: "Voucher", query: "voucher_name" },
        { name: "User", query: "t.aggregator_name" },
        { name: "Transaction ID", query: "sb_booking_code" },
        { name: "Screen", query: "t.screen_name" },
      ],
      selectedFilter: "",
      filtervalue: "",
    };
  },
  computed: {
    ...mapGetters([
      // Flags
      "getAggregatorsReportsIsCinema",
      // End
      "getAggregatorsReportList",
      "getAggregatorsReportToDate",
      "getAggregatorsReportFromDate",
      "getCinemasList",
      "getAggregatorsReportSelectedCinema",

      // EXCEL
      "getAggregatorsExcelFileName",
      // PDF
      "getAggregatorsPdfFileName",
    ]),
  },
  beforeMount() {
    let cinemaId = this.secureStore.get("USINFO")
      ? this.secureStore.get("USINFO").cinema_id
      : null;
    if (cinemaId) {
      this.onAggregatorsReportFlagHandler({
        event: null,
        name: "isCinema",
        value: cinemaId,
      });
    }
    // this.fetchCinemasList();
  },
  mounted() {},
  methods: {
    ...mapActions([
      "fetchAggregatorsReportList",
      "onAggregatorsReportDateHandler",
      "fetchCinemasList",
      "onAggregatorsReportDropdownHandler",
      "onAggregatorsReportFlagHandler",
      "onAggregatorsReportFilterHandler",
      "onAggregatorsReportSearchHandler",
    ]),
    onSelectFilter(filter) {
      this.selectedFilter = filter.name;
      this.onAggregatorsReportFilterHandler(filter.query);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/aggregatorsReport.vue